module.exports = __webpack_public_path__ + "static/media/miracleWrong.3c28da2d.png";